<template>
  <v-page class="unsubscribe-notifications">
    <div v-if="isLoading" class="d-flex justify-content-center py-4">
      <v-loader />
    </div>
    <template v-else>
      <toolbar transparent :logo="false" class="mb-3">
        <v-button rounded light raised to="/">
          <v-icon icon="arrow_back" />
        </v-button>
      </toolbar>
      <div class="text-center">
        <v-icon icon="unsubscribe" size="45px" class="mb-2" />
        <h2 class="mb-4">
          {{ $t("pages.unsubscribeFromEmail.unsubscribeSuccess") }}
        </h2>
        <div class="pt-4">
          <p>{{ $t("pages.unsubscribeFromEmail.unsubscribeByAccident") }}</p>
          <v-button to="/me/account/notifications">
            {{
              isAuthenticated
                ? $t("pages.unsubscribeFromEmail.managePreferences")
                : $t("pages.unsubscribeFromEmail.signInAndManagePreferences")
            }}
          </v-button>
        </div>
      </div>
    </template>
  </v-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import Toolbar from "@/components/Toolbar"

export default {
  data() {
    return {
      isLoading: true
    }
  },

  components: {
    Toolbar
  },

  mounted() {
    this.unsubscribeEmailNotifications({
      id: this.$route.params.id,
      type: this.$route.query.type
    }).then(() => {
      this.isLoading = false
    })
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"])
  },

  methods: {
    ...mapActions("notifications", ["unsubscribeEmailNotifications"])
  }
}
</script>
